import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Ag1ButtonSmallComponent } from '../ag1-button-small/ag1-button-small.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { NgClass, NgStyle } from '@angular/common';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-chip' instead.
 */
@Component({
  selector: 'ag1-chip',
  templateUrl: './ag1-chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Ag1ButtonSmallComponent,
    AngularSvgIconModule,
    FormsModule,
    NgClass,
    NgStyle,
  ],
})
export class Ag1ChipComponent implements OnInit, AfterViewChecked {
  @Input() placeholder: string = 'Enter text';
  @Input() validatorFn: (value: string) => boolean = () => true;
  @Input() keyword: string = 'value';
  @Input() searchList: string[] = [];
  @Input() isParentFocused: boolean = true;

  @Output() chipsChange = new EventEmitter<string[]>();

  searchTerm: string = '';
  availableSearchList: string[] = [];
  filteredSearchList: string[] = [];
  chips: string[] = [];
  inputValue: string = '';
  inputState: 'valid' | 'duplicate' | 'invalid' = 'valid';
  isFocused: boolean = false;

  inputLeftValue: string = '0px';

  ngOnInit(): void {
    this.filteredSearchList = this.searchList;
    this.availableSearchList = this.searchList;
  }

  ngAfterViewChecked() {
    // Ensure the modal's left value is recalculated after the view has been updated
    if (this.isFocused) {
      const emailInput = document.getElementById('email-input');
      const parentLeft = emailInput.offsetLeft;
      const searchListModal = document.getElementById('search-list-modal');
      if (searchListModal) {
        searchListModal.style.left = `${parentLeft.toFixed(0)}px`;
      }
    }
  }

  handleInput(event: KeyboardEvent): void {
    if (/^[a-zA-Z0-9@.]$/.test(event.key)) {
      this.inputState = 'valid';
    } else if (this.inputValue === '') {
      this.inputState = 'valid';
    }

    const inputTarget = event.target as HTMLInputElement;
    this.searchTerm = inputTarget.value || '';
    this.updateSearchFilter();
    this.filterItems();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',' || event.key === ';') {
      event.preventDefault();
      this.addChip();
    }
  }

  handleBlur(event: FocusEvent): void {
    // Skip if focus moved to a dropdown suggestion — selectItem (mousedown) handles it
    const related = event.relatedTarget as HTMLElement | null;
    if (related?.closest('#search-list-modal')) {
      this.isFocused = false;
      return;
    }
    if (event.relatedTarget) {
      const buttonTarget = event.relatedTarget as HTMLButtonElement;
      if (buttonTarget.tagName === 'BUTTON') {
        this.inputValue = buttonTarget.innerText;
      }
    }
    const value = this.inputValue.trim();
    if (value) {
      if (this.chips.includes(value)) {
        this.inputState = 'duplicate';
      } else if (!this.validatorFn(value)) {
        this.inputState = 'invalid';
      } else {
        this.addChip();
      }
    }
    this.isFocused = false;
  }

  selectItem(item: string): void {
    this.inputValue = item;
    this.addChip();
  }

  handleFocus(): void {
    this.isFocused = true;
  }

  addChip(): void {
    const chip = this.inputValue.trim();
    if (chip)
      if (this.chips.includes(chip)) {
        this.inputState = 'duplicate';
      } else if (!this.validatorFn(chip)) {
        this.inputState = 'invalid';
      } else {
        this.chips.push(chip);
        this.inputValue = '';
        this.chipsChange.emit(this.chips);
        this.inputState = 'valid';
        this.updateSearchFilter();
      }
  }

  removeChip(chip: string): void {
    this.chips = this.chips.filter((c) => c !== chip);
    this.chipsChange.emit(this.chips);
    this.updateSearchFilter();
  }

  updateSearchFilter(): void {
    this.availableSearchList = this.searchList.filter((item: string) => {
      return !this.chips.includes(item.trim());
    });
    this.filteredSearchList = this.availableSearchList;
  }

  filterItems(): void {
    if (!this.filteredSearchList?.length) {
      return;
    }

    if (
      this.searchTerm === '' ||
      this.searchTerm === null ||
      this.searchTerm === undefined
    ) {
      return;
    }

    this.filteredSearchList = this.availableSearchList.filter(
      (item: string) => {
        return item.toLowerCase().includes(this.searchTerm.toLowerCase());
      },
    );
  }
}
